import { Response } from 'types'
import axiosInstance from './axios'

export interface Certificate {
  id: number
  name: string
  timeSpent: number
  createdAt: string
  user: {
    firstname: string
    lastname: string
  }
  pdfFile: {
    mediaFileId: string
  }
}

export const getCertificates = (): Promise<Response<Certificate[]>> => {
  return axiosInstance.post('/certificates')
}
